/**
 * Auto Height JavaScript
 *
 * This file defines Auto Height
 * behavior.
 */

import { setupAutoHeightAni } from '../../util/autoHeightAni';

setupAutoHeightAni('.has-auto-height, .wp-block-cover.ani--parallax');
